import React, { useState, useEffect, useContext } from "react";
import "./Mealplans.scss";
import AddButton from "../../components/_default/AddButton";
import { getMealplansAurum, getMealplansCoach } from "../../services/firebase/firestore/getData";
import { deleteMealplanAurum, deleteMealplanCoach } from "../../services/firebase/firestore/deleteData";
import DropDown from "../../components/_default/DropDown";
import LongList from "../../components/_default/LongList";
import SearchPage from "../../components/_default/SearchPage";
import Popup from "../../components/_default/Popup";
import { deleteMediaArrayFromStorage } from "../../services/firebase/storage";
import UserContext from "../../services/context/userContext";
import aurum from "../../assets/images/aurum.png";
import { useCookies } from "react-cookie";
import logo from '../../assets/images/logo.svg';

function Mealplans(props) {
  const [cookies, setCookie] = useCookies(["from"]);

  const [mealplans, setMealplans] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [initialMealplans, setInitialMealplans] = useState(false);
  const [from, setFrom] = useState(cookies.from ? cookies.from : "aurum");

  const filters = ["Sort by name", "Sort by category"];
  const [filter, setFilter] = useState("Sort by name");
  const filterTypes = ["Ascending", "Descending"];
  const [filterType, setFilterType] = useState("Ascending");

  const user = useContext(UserContext);

  useEffect(() => {
    getMealplans();
  }, [filter, filterType]);

  useEffect(() => {
    setCookie("from", from, { path: "/" });
  }, [from]);

  function sorter(mealplans) {
      if(mealplans.aurum) {
        mealplans.aurum.sort((a,b) => {
          let firstCheck = filter === "Sort by category"? a.category : a.name;
          let secondCheck = filter === "Sort by category"? b.category : b.name;
          if (firstCheck > secondCheck) {
            return filterType == "Ascending"? 1 : -1;
          }
          if (secondCheck > firstCheck) {
            return filterType == "Ascending"? -1 : 1;
          }
            return 0;
          });
      }
      if(mealplans.coach) {
        mealplans.coach.sort((a,b) => {
          let firstCheck = filter === "Sort by category"? a.category : a.name;
          let secondCheck = filter === "Sort by category"? b.category : b.name;
          if (firstCheck > secondCheck) {
            return filterType == "Ascending"? 1 : -1;
          }
          if (secondCheck > firstCheck) {
            return filterType == "Ascending"? -1 : 1;
          }
          return 0;
        });
      }
      
    setMealplans(mealplans);
  }

  function getMealplans() {
    getMealplansAurum((aurum_result) => {
      getMealplansCoach(user.id, (coach_result) => {
        // console.log("get meal plans")
        sorter({ aurum: aurum_result, coach: coach_result });
        // setMealplans({ aurum: aurum_result, coach: coach_result });
        setInitialMealplans({ aurum: aurum_result, coach: coach_result });
        setShowPopup(false);
      })
    });
  }

  function removeMealplan(e) {
    deleteMediaArrayFromStorage([e.image], () => {
      if(from === "aurum"){
        deleteMealplanAurum(e.id, () => {
          getMealplans();
        });
      }else{
        deleteMealplanCoach(user.id, e.id, () => {
          getMealplans();
        });
      }
    });
  }

  function searchMealplansByName(e) {
    getMealplansAurum((aurum_result) => {
      getMealplansCoach(user.id, (coach_result) => {
        sorter({ aurum: aurum_result, coach: coach_result });
        let finalResult = { aurum: [], coach: [] };

        mealplans.aurum.map((item) => {
          if(item.name.toLowerCase().includes(e.target.value.toLowerCase())) {
            finalResult.aurum.push(item);
          }
        })
        mealplans.coach.map((item) => {
          if(item.name.toLowerCase().includes(e.target.value.toLowerCase())) {
            finalResult.coach.push(item);
          }
        });

        if(e.target.value === "") {
          sorter({ aurum: aurum_result, coach: coach_result });
        }else {
          sorter(finalResult);
        }  
        setShowPopup(false);
      })
    });
  }

  return (
      <div className="c-page-wrapper c-page-dashboard" style={{justifyContent: 'flex-start'}}>
        <div className="c-header">
          <div className="c-header-container">
            <div className="c-header-nav">
              <h1 className="c-header-title">Nutrition</h1>
              <ul className="c-header-nav-wrapper">
                <li className={from === "aurum" ? "--active" : ""} onClick={() => setFrom("aurum")}>
                  <div className="c-side-user-image" style={{ backgroundImage: `url('${aurum}')` }} />
                  <p>Aurum <span>({initialMealplans.aurum ? initialMealplans.aurum.length : 0})</span></p>
                </li>

                <li className={from === "coach" ? "--active" : ""} onClick={() => setFrom("coach")}>
                  <div className="c-side-user-image" style={{ backgroundImage: `url('${user.image}')` }}>
                    <p>{user.first_name[0] + user.last_name.match(/\b(\w)/g).join("")}</p>
                  </div>
                  <p>{user.first_name} <span>({initialMealplans.coach ? initialMealplans.coach.length : 0})</span> </p>
                </li>
              </ul>
            </div>
            <div className="c-header-add">
              {/* <AddButton text="New Mealplan" backgroundColor="#FFC415" color="#000" onClick={() => props.history.push("/mealplan", { update: false, from: from })} /> */}
              <AddButton text="Add Mealplan" backgroundColor="#FFC415" color="#000" onClick={() => props.history.push("/mealplan", { update: false, from: from })} />
            </div>
            <div className="c-header-logo">
              <img src={logo} alt="Logo" />
            </div>
          </div>
        </div>
        <div className="c-page-wrapper--exercises">
          <div className="c-page-main--exercises">
            <div className="c-exercise-finder">
              <SearchPage placeholder="Search mealplan" onChange={(e) =>  {searchMealplansByName(e)}}/>
              <div className="c-dropdown-holder">
                <DropDown options={filters} value={filter} onChange={(e) => setFilter(e)} zindex={66}/>
                <DropDown options={filterTypes} value={filterType} onChange={(e) => setFilterType(e)} zindex={66}/>
              </div>
            </div>
            <LongList from={from} history={props.history} pagetype="mealplan" items={mealplans[from]} removeItem={(e) => setShowPopup({ type: "mealplan", ...e })} />
          </div>
        </div>
        {showPopup && (
          <Popup
            title={"Delete mealplan"}
            button="Delete"
            deletePopup={true}
            description={"Are you sure you want to delete this mealplan? This can not be undone."}
            onAction={() => removeMealplan(showPopup)}
            onCancel={() => {
              setShowPopup(false);
            }}
          />
        )}
      </div>
  );
}

export default Mealplans;
